import React from 'react'

const NoDocument = ({children}:any) => {
  return (
    <div style={{minHeight:"52px", height:"52px", marginBottom:"10px"}}>
          {children}
    </div>
  )
}

export default NoDocument
